import { CheckCircle2, Crown, Wifi, Coffee, Briefcase, Baby } from 'lucide-react';

const differentiators = [
  {
    icon: Crown,
    title: 'Executive Fleet',
    description: 'Latest Mercedes S-Class, BMW 7 Series, and luxury SUVs',
    features: ['Premium leather interiors', 'Climate control', 'Tinted windows'],
  },
  {
    icon: Wifi,
    title: 'Business Ready',
    description: 'Stay productive with complimentary business amenities',
    features: ['High-speed WiFi', 'Charging stations', 'Privacy partition'],
  },
  {
    icon: Coffee,
    title: 'Premium Comfort',
    description: 'Enjoy refreshments and personalized service',
    features: ['Bottled water', 'Newspapers', 'Climate control'],
  },
  {
    icon: Briefcase,
    title: 'Professional Chauffeurs',
    description: 'Experienced, vetted, and impeccably dressed drivers',
    features: ['Background checked', 'Multilingual', 'Local experts'],
  },
];

const ServiceDifferentiators = () => {
  return (
    <section className="py-20 section-cream">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-secondary mb-4">
            The Brussels VIP Difference
          </h2>
          <div className="luxury-divider mb-6"></div>
          <p className="text-xl text-gray-600">
            Experience the pinnacle of luxury transportation with exclusive features and unmatched service quality
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {differentiators.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="luxury-card p-8 rounded-xl hover:-translate-y-1"
              >
                <div className="flex items-start gap-6">
                  <div className="w-14 h-14 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon className="w-7 h-7 text-primary" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-serif font-semibold text-secondary mb-2">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 mb-4">{item.description}</p>
                    <ul className="space-y-2">
                      {item.features.map((feature, idx) => (
                        <li key={idx} className="flex items-center gap-2 text-sm text-gray-600">
                          <CheckCircle2 className="w-4 h-4 text-primary flex-shrink-0" />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-block bg-white p-8 rounded-xl shadow-lg">
            <div className="flex items-center gap-4 mb-4">
              <Baby className="w-8 h-8 text-primary" />
              <div className="text-left">
                <h4 className="text-lg font-semibold text-secondary">Family-Friendly Options</h4>
                <p className="text-gray-600 text-sm">Child seats available upon request</p>
              </div>
            </div>
            <p className="text-gray-500 text-sm">
              Safety-certified child seats for all ages • No additional charge
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceDifferentiators;
